export default __webpack_public_path__ + "static/media/menu.3a24a230.svg";